/*
 * COPYRIGHT (c) 2022
 * HONEYWELL INC.,
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React from 'react';
import { DataContextProvider } from '@forge/data-connector';
import IEnergyManagementProps from '../IEnergyManagementProps';
import { Card } from '@scuf/common';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../locales/en-US/descriptors';
import EmaasEnergyUsageGraphKPIHOC from './EmaasEnergyUsageGraphKPIHOC/EmaasEnergyUsageGraphKPIHOC';
import '../../../scss/KPICardTheme.scss';

const EmaasEnergyUsageGraphKPIWidget = (props: IEnergyManagementProps) => {
  const { connectorConfig, requestContext, emaasContext } = props;
  const d = descriptors.energyManagement;
  const [t] = useTranslation();

  return (
    <DataContextProvider config={connectorConfig}>
      <div className="emaas-energyusage-container kpi-card-common energy-graph">
        <Card>
          <Card.Content className="kpi-content-container">
            <EmaasEnergyUsageGraphKPIHOC
              requestContext={requestContext}
              emaasContext={emaasContext}
            />
          </Card.Content>
        </Card>
      </div>
    </DataContextProvider>
  );
};

export default EmaasEnergyUsageGraphKPIWidget;
